import { MainMenu } from '../components/MainMenu';
import { Outlet } from 'react-router';
import { MAIN_MENU_ITEM_GROUPS } from '../configuration/main-menu.configuration';
import { FunctionComponent, useMemo } from 'react';
import { LocationDrawerProvider } from '@/modules/locations/contexts/LocationDrawerContext';
import { useAuthUserContext } from '@/modules/auth';
import { isBetaTenant, isTransactionsOnlyTenant } from '@/config/tenant-features';
import { MainMenuItemGroup } from '../types/MenuItem';

export const ApplicationLayout: FunctionComponent = () => {
  const { tenantId } = useAuthUserContext();

  const filteredMenuItemGroups = useMemo(() => {
    const isTransactionsOnly = isTransactionsOnlyTenant(tenantId);

    return MAIN_MENU_ITEM_GROUPS.map((group) => ({
      ...group,
      children: group.children?.filter((item) => {
        // Filter out transactions menu item if tenant doesn't have beta access
        if (item.url === '/app/transactions') {
          return isBetaTenant(tenantId);
        }
        // Filter out events, assets, and movements menu items for transactions-only tenants
        if (item.url === '/app/events' || item.url === '/app/assets' || item.url === '/app/movements') {
          return !isTransactionsOnly;
        }
        return true;
      }),
    })).filter((group) => (group.children?.length ?? 0) > 0); // Remove empty groups
  }, [tenantId]) as MainMenuItemGroup[];

  return (
    <LocationDrawerProvider>
      <div className="flex min-h-screen w-full">
        <MainMenu mainMenuItemGroups={filteredMenuItemGroups} />

        <div className="flex-grow">
          <Outlet />
        </div>
      </div>
    </LocationDrawerProvider>
  );
};
